export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAEAQMAAADVia+XAAAAA1BMVEX///+nxBvIAAAACklEQVQI12PAAgAAFAAB8OkRlAAAAABJRU5ErkJggg=="